import React from "react";
import {Editor} from "components";
import GagePatternData from "./GagePatternData";
import GageDimensions from "./GageDimensions";
import GageSeriesData from "./GageSeriesData";
import Page from "../Page";

const styles = {
  notes: {
    padding: '10px 0'
  }
};

const Template = (props) => {
  const {
    removableArea: RemovableArea,
    gagePatternData,
    gageDimensions,
    gageSeriesData,
    notes,
    imgSrc,
    onImgSelected,
    product,
    contentRef,
    index
  } = props;

  const onContentOverflow = (height) => props.onContentOverflow(index, height);
  const onContentLack = (height) => props.onContentLack(index, height);
  const selectImage = (value) => onImgSelected(index, value);

  const setNotesContent = (value) => props.setContent('notes', value);
  const setGageSeriesDataContent = (value) =>
    props.setContent('gageSeriesData', value);
  const setGagePatternData = (subId, value) =>
    props.setContent(`gagePatternData.${subId}`, value);

  return (
    <Page
      removableArea={RemovableArea}
      product={product}
      onContentOverflow={onContentOverflow}
      onContentLack={onContentLack}
    >
      <div id="content" ref={contentRef}>
        {gagePatternData && <GagePatternData
          removableArea={RemovableArea}
          imgSrc={imgSrc}
          onImgSelected={selectImage}
          content={props.content.gagePatternData}
          setContent={setGagePatternData}
          product={product}
        />}
        {gageDimensions && <GageDimensions
          removableArea={RemovableArea}
          product={product}/>
        }
        {gageSeriesData && <GageSeriesData
          removableArea={RemovableArea}
          content={props.content.gageSeriesData}
          setContent={setGageSeriesDataContent}
          product={product} />
        }
        {notes && <Editor
          id="notes"
          content={props.content.notes}
          setContent={setNotesContent}
          style={styles.notes} />
        }
      </div>
    </Page>
  );
}

export default Template;
